import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUiStore } from '@/stores/ui';
import { setDocumentLocale } from '@/i18n';
import { useDocumentSeo } from '@/composables/useDocumentSeo';
import type { LocaleCode } from '@/data/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const ui = useUiStore();
const { locale } = useI18n();

useDocumentSeo();

watch(
  locale,
  (value) => {
    setDocumentLocale(value as LocaleCode);
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app-root",
    class: _normalizeClass({ light: _unref(ui).isLightTheme })
  }, [
    _createVNode(_component_router_view)
  ], 2))
}
}

})